export let IconSize = /*#__PURE__*/function (IconSize) {
  IconSize[IconSize["ExtraSmall"] = 16] = "ExtraSmall";
  IconSize[IconSize["Small"] = 20] = "Small";
  IconSize[IconSize["Medium"] = 24] = "Medium";
  IconSize[IconSize["Large"] = 32] = "Large";
  return IconSize;
}({});